import { render, staticRenderFns } from "./ReportTemplateForm.vue?vue&type=template&id=4c685e0c"
import script from "./ReportTemplateForm.vue?vue&type=script&lang=js"
export * from "./ReportTemplateForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports